import { createBrowserHistory } from 'history';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import authReducer from 'app/store/reducers/auth.reducer';
import userReducer from 'app/store/reducers/user.reducer';
import assetReducer from 'app/store/reducers/asset.reducer';
import categoryReducer from 'app/store/reducers/category.reducer';
import customerReducer from 'app/store/reducers/customer.reducer';
import menuItemReducer from 'app/store/reducers/menuItem.reducer';
import orderReducer from 'app/store/reducers/order.reducer';
import promoReducer from 'app/store/reducers/promo.reducer';
import qrReducer from 'app/store/reducers/qr.reducer';
import ratingReducer from 'app/store/reducers/rating.reducer';
import statisticReducer from 'app/store/reducers/statistic.reducer';
import storeReducer from 'app/store/reducers/store.reducer';
import bitecoinReducer from 'app/store/reducers/bitecoin.reducer';
import purchaseOrder from 'app/store/reducers/purchaseOrder.reducer';
import trackStore from 'app/store/reducers/trackStore.reducer';
import stockReconciliation from 'app/store/reducers/stockReconciliation.reducer';
import monitorSalesReducer from 'app/store/reducers/monitorSales.reducer';
import announcementReducer from 'app/store/reducers/announcement.reducer';
import regionReducer from 'app/store/reducers/region.reducer';
import improveQscReducer from 'app/store/reducers/improveQsc.reducer';
import analyzeChannelsReducer from 'app/store/reducers/analyzeChannels.reducer';

const { createReduxHistory, routerReducer, routerMiddleware } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const appReducers = combineReducers({
  router: routerReducer,
  auth: authReducer,
  user: userReducer,
  asset: assetReducer,
  category: categoryReducer,
  customer: customerReducer,
  menuItem: menuItemReducer,
  order: orderReducer,
  promo: promoReducer,
  qr: qrReducer,
  rating: ratingReducer,
  statistic: statisticReducer,
  store: storeReducer,
  bitecoin: bitecoinReducer,
  purchaseOrder: purchaseOrder,
  trackStore: trackStore,
  stockReconciliation: stockReconciliation,
  monitorSales: monitorSalesReducer,
  announcement: announcementReducer,
  region: regionReducer,
  improveQsc: improveQscReducer,
  analyzeChannels: analyzeChannelsReducer,
});

export const store = configureStore({
  reducer: appReducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(routerMiddleware),
});

export const history = createReduxHistory(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
